import { Box, BoxProps, Button, Text } from "@chakra-ui/react";
import { useState } from "react";

interface Props extends BoxProps {
  data: string | undefined;
  maxLength?: number;
}

export const ReadMore = ({ data, maxLength = 160, ...rest }: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const displayText = isExpanded
    ? data
    : `${data && data.substring(0, maxLength)}...`;

  if (data && data.length < maxLength) {
    return (
      <Box {...rest}>
        <Text textStyle={"b-reg"}>{data}</Text>
      </Box>
    );
  }

  return (
    <Box {...rest}>
      <Text textStyle={"b-reg"}>{displayText}</Text>
      <Button
        size="sm"
        variant="link"
        colorScheme="red"
        onClick={toggleReadMore}
        _hover={{ textDecoration: "none" }}
      >
        {isExpanded ? "Lebih sedikit" : "Baca Selengkapnya"}
      </Button>
    </Box>
  );
};
